import { Base } from '../base-component';

import './carousel-fullwidth-item.component.scss';
import SliderComponent from '../slider/slider.component';
import { MediaQueryService } from 'services/media-query.service';

export class CarouselFullwidthItem extends Base {

	constructor(element){
		super(element)
	}

	init(){};

	bindEvents(){};

}



// WEBPACK FOOTER //
// ./components/carousel-fullwidth-item/carousel-fullwidth-item.component.ts